import { render, staticRenderFns } from "./MainNotifications.vue?vue&type=template&id=4cef30ce&scoped=true"
import script from "./MainNotifications.vue?vue&type=script&lang=js"
export * from "./MainNotifications.vue?vue&type=script&lang=js"
import style0 from "./MainNotifications.vue?vue&type=style&index=0&id=4cef30ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef30ce",
  null
  
)

export default component.exports